import Appointment from './objectDefinitions/Appointment';
import AutomationPlatformFlow from './objectDefinitions/AutomationPlatformFlow';
import Call from './objectDefinitions/Call';
import Campaign from './objectDefinitions/Campaign';
import Cart from './objectDefinitions/Cart';
import CommercePayment from './objectDefinitions/CommercePayment';
import Communication from './objectDefinitions/Communication';
import ContactCreateAttribution from './objectDefinitions/ContactCreateAttribution';
import Conversation from './objectDefinitions/Conversation';
import ConversationSession from './objectDefinitions/ConversationSession';
import Course from './objectDefinitions/Course';
import DataPrivacyRequest from './objectDefinitions/DataPrivacyRequest';
import DealRegistration from './objectDefinitions/DealRegistration';
import DealSplit from './objectDefinitions/DealSplit';
import Email from './objectDefinitions/Email';
import FeedbackSubmission from './objectDefinitions/FeedbackSubmission';
import FeedbackSurvey from './objectDefinitions/FeedbackSurvey';
import Forms from './objectDefinitions/Forms';
import GoalTarget from './objectDefinitions/GoalTarget';
import Import from './objectDefinitions/Import';
import Invoice from './objectDefinitions/Invoice';
import Lead from './objectDefinitions/Lead';
import Listing from './objectDefinitions/Listing';
import MarketingEmail from './objectDefinitions/MarketingEmail';
import MarketingSms from './objectDefinitions/MarketingSms';
import MeetingEvent from './objectDefinitions/MeetingEvent';
import Note from './objectDefinitions/Note';
import ObjectLists from './objectDefinitions/ObjectLists';
import Order from './objectDefinitions/Order';
import PartnerAccount from './objectDefinitions/PartnerAccount';
import PartnerClient from './objectDefinitions/PartnerClient';
import PartnerService from './objectDefinitions/PartnerService';
import PaymentLink from './objectDefinitions/PaymentLink';
import PostalMail from './objectDefinitions/PostalMail';
import PublishingTask from './objectDefinitions/PublishingTask';
import Sequence from './objectDefinitions/Sequence';
import SequenceEnrollment from './objectDefinitions/SequenceEnrollment';
import Service from './objectDefinitions/Service';
import Subscription from './objectDefinitions/Subscription';
import Task from './objectDefinitions/Task';
import User from './objectDefinitions/User';
import CustomerSuccessAlert from './objectDefinitions/CustomerSuccessAlert';
import Contract from './objectDefinitions/Contract';
const ObjectDefinitions = [Appointment, AutomationPlatformFlow, Call, Campaign, Cart, CommercePayment, Communication, ContactCreateAttribution, Contract, Conversation, ConversationSession, Course, CustomerSuccessAlert, DataPrivacyRequest, DealRegistration, DealSplit, Email, FeedbackSubmission, FeedbackSurvey, Forms, GoalTarget, Import, Invoice, Lead, Listing, MarketingEmail, MarketingSms, MeetingEvent, Note, ObjectLists, Order, PartnerAccount, PartnerClient, PartnerService, PaymentLink, PostalMail, PublishingTask, Sequence, SequenceEnrollment, Service, Subscription, Task, User];
const getObjectDefinitions = () => ObjectDefinitions;
export default getObjectDefinitions;